import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Alert, AlertDescription } from "@envirohub/ui";
import { AlertCircle } from "lucide-react";
import { ChangePasswordCard } from "@/components/ChangePasswordCard";

export default function ChangePasswordPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-6">
      <Alert>
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>{t("auth.mustResetPasswordRedirect")}</AlertDescription>
      </Alert>
      <ChangePasswordCard forced onCompleted={() => navigate("/", { replace: true })} />
    </div>
  );
}
